import {createSlice} from '@reduxjs/toolkit';
import {httpDelete, httpGet, httpPost} from '../../../util/Rest';
import {
  STATE,
  CLIENT_CLASS,
  LOCATION_CODE,
  SERVICE_TYPE,
  FEE_TYPE,
  ORG_CLIENT_CLASS,
  INVOICE_TYPE,
  ORG_TYPE,
} from '../../../constants/Lookup';
import {submissionEnd} from '../CommonActions/commonActions';

const initialData = {
  corporateAPIdata: [],
  invoiceAPIdata: [],
  companyAPIdata: [],
  clientNumberAPIdata: [],
  siteAPIdata: [],
  organizationAPIdata: [],
  clientClassData: [],
  serviceIdData: [],
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  status: null,
  serviceClientInfo: null,
  contactsData: null,
  addressData: null,
  phonesData: null,
  notesData: null,
  dropDownData: null,
  editContactData: null,
  editContactPhoneData: null,
  editAddressData: null,
  siteDataOnCorporate: null,
  serviceDataOnCompany: null,
  allGroupCode: [],
  allCompanyNames: [],
  allCorporateNames: [],
  allClientNames: [],
  contacTableData: [],
  phoneTableData: [],
  addressTableData: [],
  notesTableData: [],
  sitePrefixData : [],
};

const slice = createSlice({
  name: 'organization',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
      state.status = action.payload.status;
    },
    fetchSaveAllSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
      state.status = null;
    },
    fetchCompanyType: (state, action) => {
      state.companyAPIdata = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },

    fetchClientNumberType: (state, action) => {
      state.clientNumberAPIdata = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },

    fetchCorporateType: (state, action) => {
      state.corporateAPIdata = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchInvoiceType: (state, action) => {
      state.invoiceAPIdata = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchSiteType: (state, action) => {
      state.siteAPIdata = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getSiteDataOnCorporate: (state, action) => {
      state.siteDataOnCorporate = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getServiceDataOnCompany: (state, action) => {
      state.serviceDataOnCompany = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchOrganization: (state, action) => {
      state.organizationAPIdata = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchClientClass: (state, action) => {
      state.clientClassData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getServiceClientData: (state, action) => {
      state.serviceClientInfo = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getContactsData: (state, action) => {
      state.contactsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getEditContactData: (state, action) => {
      state.editContactData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getEditAddressData: (state, action) => {
      state.editAddressData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getEditContactPhoneData: (state, action) => {
      state.editContactPhoneData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getAddressData: (state, action) => {
      state.addressData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getPhonesData: (state, action) => {
      state.phonesData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getNotesData: (state, action) => {
      state.notesData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getAllGroupCode: (state, action) => {
      state.allGroupCode = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getAllCompanyNames: (state, action) => {
      state.allCompanyNames = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getAllCorporateNames: (state, action) => {
      state.allCorporateNames = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getAllClientNames: (state, action) => {
      state.allClientNames = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },

    fetchServiceId: (state, action) => {
      state.serviceIdData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.status = null;
    },
    resetEditData: (state) => {
      state.serviceClientInfo = null;
      state.contactsData = null;
      state.addressData = null;
      state.phonesData = null;
      state.notesData = null;
      state.contactsData = null;
      state.editContactData = null;
      state.editAddressData = null;
      state.editContactPhoneData = null;
      state.status = null;
    },
    resetEditTableData: (state) => {
      state.editContactData = null;
      state.editAddressData = null;
      state.editContactPhoneData = null;
      state.status = null;
    },
    postServiceClientData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
      state.status = action.payload.status;
    },
    postSiteData: (state, action) => {
      state.status = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    postCorporateData: (state, action) => {
      state.status = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    postCompanyData: (state, action) => {
      state.status = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    getConatctInfoData: (state, action) => {
      state.contacTableData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getPhoneInfoData: (state, action) => {
      state.phoneTableData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getClinentAddressData: (state, action) => {
      state.addressTableData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getClinentNotesData: (state, action) => {
      state.notesTableData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetClientInfoData: (state) => {
      state.isLoading = false;
      state.contacTableData = [];
      state.phoneTableData = [];
    },
    resetSiteDataOnCorporate: (state) => {
      state.siteDataOnCorporate = [];
    },
    
    fetchSitePrefix: (state, action) => {
      state.sitePrefixData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchOrganization,
  fetchCompanyType,
  fetchClientNumberType,
  fetchCorporateType,
  resetSiteDataOnCorporate,
  fetchInvoiceType,
  fetchSiteType,
  fetchClientClass,
  fetchServiceId,
  fetchStart,
  fetchError,
  resetMsg,
  postServiceClientData,
  postSiteData,
  postCorporateData,
  postCompanyData,
  getServiceClientData,
  getContactsData,
  getEditContactData,
  getEditContactPhoneData,
  getEditAddressData,
  getAddressData,
  getPhonesData,
  getNotesData,
  resetEditData,
  fetchSuccess,
  fetchSaveAllSuccess,
  fetchDropDownData,
  resetEditTableData,
  getSiteDataOnCorporate,
  getServiceDataOnCompany,
  getAllGroupCode,
  getAllCompanyNames,
  getAllCorporateNames,
  getAllClientNames,
  getConatctInfoData,
  getPhoneInfoData,
  resetClientInfoData,
  getClinentAddressData,
  getClinentNotesData,
  fetchSitePrefix,
} = slice.actions;

export const fetchCompanyDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`company/findall/companylevelid`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchCompanyType(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchClientPrefixData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`organization/get/all/cleintprefix`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchSitePrefix(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchClientNumberDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`maintenance/find/all/clientNumber`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchClientNumberType(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchCorporateDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`company/findall/corporateLevelId`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchCorporateType(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchSiteDataBasedOnCorporate = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`business/findall/sites/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getSiteDataOnCorporate(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchServiceDataBasedOnCompany = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`business/find/servicename/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getServiceDataOnCompany(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchInvoiceTypeDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`company/find/all/invoicetype`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchInvoiceType(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchSiteDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`company/find/all/sitelevelid`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchSiteType(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchClientClassData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`business/findall/clientclass`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchClientClass(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchServiceIdData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`business/find/all/serviceid`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchServiceId(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchDropDowns = () => {
  return (dispatch) => {
    httpPost(`lookup/find/all/lookup`, {
      typeCode: [
        STATE,
        LOCATION_CODE,
        CLIENT_CLASS,
        SERVICE_TYPE,
        FEE_TYPE,
        ORG_CLIENT_CLASS,
        INVOICE_TYPE,
        ORG_TYPE,
        'CONTACT_TYPE',
        'PHONE_TYPE',
        'CLIENT_PHONE_TYPE',
        //  "ADDRESS_TYPE",
        'CLIENT_ADDRESS_TYPE',
        'ADDRESS_FLAG',
        // "ORGANIZATION_PHONE_TYPE",
      ],
    })
      .then((response) => {
        if (response?.status && response.status === 200) {
          dispatch(fetchDropDownData(response.data));
        } else {
          dispatch(fetchError(response?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const getServiceClientDetails = (id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(
      type === 'Service-Client' ?
        `business/find/serviceclient/${id}` :
        `company/find/${type?.toLowerCase()}/${id}`,
    )
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getServiceClientData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

// --------contacts starts-------------------------

export const getContactsDetails = (id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`organization/get/contact/${id}/${type}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getContactsData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getEditContactDetails = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`organization/get/contact/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getEditContactData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postContactsData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`organization/save/contacts`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postContactsListData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`organization/save/organizationContacts`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const deleteClient = (id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpDelete(
      type === 'Service-Client' ?
        `business/delete/serviceclient/${id}` :
        `company/delete/${type?.toLowerCase()}/${id}`,
    )
      .then((data) => {
        if (data && data?.data?.status && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

// -------contacts ends and address starts---------

export const getAddressDetails = (id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`organization/find/orgaddress/${id}/${type}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getAddressData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getEditAddressDetails = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`organization/find/organizationAddress/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getEditAddressData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postAddressData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`organization/save/organizationaddress`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postAddressListData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`organization/saveall/organizationsaddress`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

// ---------address ends and phones starts---------

export const getPhonesDetails = (id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`organization/get/orgphone/${id}/${type}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getPhonesData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getEditContactPhoneDetails = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`organization/find/orgphone/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getEditContactPhoneData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postPhonesData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`organization/save/orgphone`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postPhonesListData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`organization/saveall/orgphone`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(fetchSaveAllSuccess(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

// ------------phone ends and notes starts----------
export const getNotesDetails = (id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`organization/find/orgnotes/${id}/${type}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getNotesData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postNotesData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`organization/save/organizationnotes`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(fetchSaveAllSuccess(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
// ------------------
export const searchOrganizationDtata = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`organization/search/all`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchOrganization(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postServiceClientInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`business/save/service/client`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postServiceClientData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postSiteInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`company/save/site`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postSiteData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postCorporateInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`company/save/corporate`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postCorporateData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postCompanyInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`company/save/company`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postCompanyData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchAllGroupCode = () => {
  return (dispatch) => {
    httpGet(`company/find/all/sitename`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllGroupCode(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchAllCompanyName = () => {
  return (dispatch) => {
    httpGet(`company/find/all/company/names`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllCompanyNames(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchAllCorporateName = () => {
  return (dispatch) => {
    httpGet(`company/findall/corporatename`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllCorporateNames(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchAllClientName = () => {
  return (dispatch) => {
    httpGet(`business/find/all/clientname`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllClientNames(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchContactData = (clientCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`clientOrganization/get/contact/${clientCode}/Service-Client`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getConatctInfoData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchPhoneData = (clientCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`clientOrganization/get/orgphone/${clientCode}/Service-Client`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getPhoneInfoData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAddressData = (clientCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`clientOrganization/get/address/${clientCode}/Service-Client`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClinentAddressData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchNotesData = (clientCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`clientOrganization/find/orgnotes/${clientCode}/Service-Client`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClinentNotesData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetClientInfo = () => {
  return (dispatch) => {
    dispatch(resetClientInfoData());
  };
};
